"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGS_STYLES = exports.LogStylesTypeEnum = void 0;
// eslint-disable-next-line no-shadow
var LogStylesTypeEnum;
(function (LogStylesTypeEnum) {
    LogStylesTypeEnum["main"] = "main";
    LogStylesTypeEnum["success"] = "success";
    LogStylesTypeEnum["error"] = "error";
    LogStylesTypeEnum["warning"] = "warning";
})(LogStylesTypeEnum = exports.LogStylesTypeEnum || (exports.LogStylesTypeEnum = {}));
exports.LOGS_STYLES = {
    main: 'color: blue;padding:3px;',
    success: 'color: green;padding:3px;',
    error: 'color: white;background:red;padding:3px;',
    warning: 'color: black;background:orange;padding:3px;',
};
